module.exports = __webpack_public_path__ + "static/media/998150.f14a3313.jpg";